var map = {
	"./feature_buy_bonus_cn.png": "f9fc",
	"./feature_buy_bonus_en.png": "cdad",
	"./feature_buy_bonus_id.png": "1ddf",
	"./feature_buy_bonus_ko.png": "9970",
	"./feature_buy_bonus_ph.png": "756d",
	"./feature_buy_bonus_th.png": "3723",
	"./feature_buy_bonus_zh.png": "5bef",
	"./feature_buy_cn.png": "3dbd",
	"./feature_buy_en.png": "9e6e",
	"./feature_buy_freespin_cn.png": "4f85",
	"./feature_buy_freespin_en.png": "d554",
	"./feature_buy_freespin_id.png": "6bd1",
	"./feature_buy_freespin_ko.png": "b337",
	"./feature_buy_freespin_ph.png": "eb81",
	"./feature_buy_freespin_th.png": "891c",
	"./feature_buy_freespin_zh.png": "33ad9",
	"./feature_buy_id.png": "122c",
	"./feature_buy_ko.png": "ebf4",
	"./feature_buy_ph.png": "1f16",
	"./feature_buy_th.png": "0fd1",
	"./feature_buy_zh.png": "e2c7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "107a";